import React from "react";
//MUI
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

const ActionBox = ({ children, sx, isShown }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        backgroundColor: theme.palette.gray.main,
        border: "none",
        borderRadius: "10px",
        fontSize: "12px",
        width: "max-content",
        padding: ".5rem",
        boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.20)",
        textAlign: "left",
        display: isShown ? "block" : "none",
        zIndex: "999",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default ActionBox;
